export default function () {
  if (document.querySelector('.about')) {
    // eslint-disable-next-line no-unused-expressions
    import(/* webpackChunkName: "about" */ '../_03_organisms/about');
  }
}
